module.exports = __webpack_public_path__ + "img/png.93398985.png";